import { Service } from "../mainService";
import { NovoUsuario } from "@/types/administracao/usuarios/novo-usuario";
import { Usuario } from "@/types/administracao/usuarios/usuario";
import { PortalError } from "@/types/portal-error";

const novoUsuarioService = {
  criarNovoUsuario,
  obterAnexoDeNovoUsuario,
  findByCpf,
  salvarEdicaoNovoUsuario,
  confirmarCodigoEmail,
  reenviarCodigoEmail
}

async function criarNovoUsuario(
  data: NovoUsuario,
): Promise<any> {
  try {
    const url = `${process.env.VUE_APP_API_USUARIOS}novo-usuario/`;
    const response = await Service.$http.post(url, data.toFormData());
    if (response && response.status === 200 || response.status === 201) {
      return new NovoUsuario(response.data);
    }
    throw new PortalError("Falha ao salvar dados do usuário.");
  } catch (e: any) {
    console.error("capotou no service", e);
    if ([400, 403].includes(e.response?.status)) throw montarArrayDeErros(e);
    throw e;
  }
}

async function obterAnexoDeNovoUsuario(idAnexo: number): Promise<any> {
  const response = await Service.$http.get(
    `${process.env.VUE_APP_API_USUARIOS}novo-usuario/admin/downloadAnexo/${idAnexo}`, { responseType: 'blob' }
  )
  if (response && response.status === 200) return response.data
  else throw new PortalError('Erro ao obter anexo do novo usuário')
}

function montarArrayDeErros(e: any): PortalError {
  if (e.response.data.erros) return new PortalError(e.response.data.erros);
  if (e.response.data.message) return new PortalError(e.response.data.message);
  return new PortalError(e);
}

async function findByCpf(): Promise<NovoUsuario | null> {
  try {
    const response = await Service.$http.get(`${process.env.VUE_APP_API_USUARIOS}novo-usuario/findByCpf`);
    if (!response || response.status !== 200) {
      console.error("Falha ao buscar usuários", response);
      throw new PortalError(response.data?.msg ?? "Falha ao buscar usuários");
    }
    return response.data
  } catch (error: any) {
    if ([401].includes(error.response?.status)) return null
    console.error("findByCpf capotou no service", error);
    if ([400, 403].includes(error.response?.status)) throw montarArrayDeErros(error);
    throw error;
  }
}

async function salvarEdicaoNovoUsuario(user: NovoUsuario): Promise<NovoUsuario> {
  try {
    const usuarioEdit: any = user
    usuarioEdit.ID_MUNICIPIO = Number(user.ID_MUNICIPIO)
    const response = await Service.$http.patch(
      `${process.env.VUE_APP_API_USUARIOS}novo-usuario`, usuarioEdit.toFormData()
    );
    if (response.status === 200) return Object.assign(new Usuario(), response.data);
    throw new PortalError("Falha ao salvar dados do usuário.");
  } catch (e: any) {
    console.error("salvarEdicaoNovoUsuario capotou no service", e);
    if ([400, 403].includes(e.response?.status)) throw montarArrayDeErros(e);
    throw e;
  }
}

async function confirmarCodigoEmail(codgio: string): Promise<any> {
  const response = await Service.$http.patch(
    `${process.env.VUE_APP_API_USUARIOS}novo-usuario/ConfirmarEmail/${codgio}`
  )
  if (response && response.status === 200) return response.data
  else throw new PortalError('Erro ao confirmar codigo de ativação')
}

async function reenviarCodigoEmail(): Promise<any> {
  const response = await Service.$http.get(
    `${process.env.VUE_APP_API_USUARIOS}novo-usuario/reenviarCodigoAtivacao`
  )
  if (response && response.status === 200) return response.data
  else throw new PortalError('Erro ao reenviar codigo de ativação')
}

export default novoUsuarioService